import React from 'react';
import {
  FaInstagram,
  FaTelegramPlane,
  FaTiktok,
  FaWhatsapp,
  FaYoutube,
} from 'react-icons/fa';
import { profile } from '../data/portfolio';

const socialLinks = [
  { label: 'Instagram', href: profile.socials.instagram, icon: <FaInstagram /> },
  { label: 'YouTube', href: profile.socials.youtube, icon: <FaYoutube /> },
  { label: 'TikTok', href: profile.socials.tiktok, icon: <FaTiktok /> },
  { label: 'WhatsApp', href: profile.socials.whatsapp, icon: <FaWhatsapp /> },
  {
    label: 'Telegram',
    href: profile.socials.telegram,
    icon: <FaTelegramPlane />,
  },
];

const SocialLinks = ({ className = '' }) => (
  <div className={`flex items-center gap-4 ${className}`}>
    {socialLinks.map((item) => (
      <a
        key={item.label}
        className='icon-button'
        href={item.href}
        target='_blank'
        rel='noreferrer'
        aria-label={item.label}
        title={item.label}
      >
        {item.icon}
      </a>
    ))}
  </div>
);

export default SocialLinks;
